import { checkHotlead } from "../services/merpservices";

const HotLeadMessage = async (ret_msg, glid, empid, ak, parentGlid) => {
    let htmsg = "";
    let download_date = "";
    let defaulter_date = "";
    let assigned_to = "";
    try {
      const res = await checkHotlead(glid, empid, ak);
      if (res?.data?.status === 200) {
        download_date = res?.data?.data?.downDate ?? "";
        defaulter_date = res?.data?.data?.pnsDefDate ?? "";
        assigned_to = res?.data?.data?.assignedTo ?? "";
      }
    } catch (error) {
        console.log(error)
    }

    if (ret_msg === "180 Days Download") {
      let downloadDate = new Date(defaulter_date);
      downloadDate.setDate(downloadDate.getDate() + 180);

      let formattedDate = `${downloadDate.getDate()}-${
        downloadDate.getMonth() + 1
      }-${downloadDate.getFullYear()}`;

      htmsg = `Supplier has been downgraded his services from Paid to Free on ${download_date} As per the process, supplier can only be re-onboarded on annual mode. If the client is okay with Annual Payment mode then raise ticket else to inform to call us back again after  ${formattedDate}`;
    } else if (ret_msg === "1DAY") {
      htmsg =
        "Your request has already been forwarded to our Sales team today. Please expect a call from our Sales team within 24 to 48 hours.";
    } else if (
      ret_msg === "No GST Child Company" ||
      ret_msg === "Duplicate Company"
    ) {
      htmsg =
        `This is a child account, please mark parent account (GL ID: ${parentGlid}) as Hot Lead and mention the customer's calling number in the STS Comments.`;
    } else if (ret_msg === "FOREIGN") {
      htmsg =
        "We will not be able to take your registration request as IndiaMART services are currently being offered to supplier based in Domestic Market only. We will definitely reach out to you in case we start offering services in international market as well.";
    } else if (ret_msg === "FRAUD") {
      htmsg =
        "We will not be able to offer you paid services as our records indicate your profile has been temporarily suspended due to suspicious activity. Please mark us an email at customercare@indiamart.com regarding this and we will definitely assist you.";
    } else if (ret_msg === "IM EMP") {
      htmsg =
        "Your profile is listed as IndiaMART Employee in our records therefore we will not be able to provide you paid services.";
    } else if (ret_msg === "NEGATIVE POOL") {
      let downloadDate = new Date(defaulter_date);
      downloadDate.setDate(downloadDate.getDate() + 180);
      let formattedDate = `${downloadDate.getDate()}-${
        downloadDate.getMonth() + 1
      }-${downloadDate.getFullYear()}`;
      if (assigned_to === "34899") {
        htmsg =
          "STS Assigned to DA Pool. STS belongs to friends & family members of IndiaMART. Please raise a ticket.";
      } else if (assigned_to === "48895") {
        htmsg = `STS Assigned to PNS Defaulter Pool. Your listing was suppressed from IndiaMART as you were not answering IndiaMART Buyer Calls. We will not be able to offer you paid services for next 1 Year i.e. till ${formattedDate}`;
      } else if (assigned_to === "32416") {
        htmsg =
          "We will not be able to offer you paid services as our records indicate your profile has been temporarily suspended due to suspicious activity. Please mark us an email at customercare@indiamart.com regarding this and we will definitely assist you.";
      } else if (assigned_to === "44998") {
        htmsg = `Supplier has been downgraded his services from Paid to Free on ${downloadDate}. As per the process, paid services cannot be offered again for 180 days. Please advise the supplier to call us back again after ${formattedDate}`;
      } else if (assigned_to === "84448") {
        htmsg =
          "Our records indicate that you have IndiaMART Services in past. Please activate your paid service by visiting Seller. IM";
      } else if (assigned_to === "55018") {
        htmsg =
          "We will not be able to provide you paid services due CIN/GST/LLP number inavalibility in your account, Kindly call after updating the required details in your account";
      } else if (
        assigned_to === "65751" ||
        assigned_to === "44999" ||
        assigned_to === "68160"
      ) {
        htmsg = `Supplier has downgraded his services from Paid to Free on ${downloadDate}. Please raise Ticket for Paid services`;
      } else if (assigned_to === "86525") {
        htmsg =
          "Currently we will not be able to provide you Paid Services due to low demand on Indiamart platform, resulting in ROI issues.";
      } else if (assigned_to === "47835") {
        htmsg =
          "If account is disabled, kindly ask customer  to enable the account first, If account is enabled then kindly raise ticket";
      }
    } else if (ret_msg === "PROFORMA") {
      htmsg =
        "STS cannot be marked as Hot Lead as a proforma was issued on the account in last 90 days. Please check if we've already received a payment from the client. If not, please raise a ticket.";
    } else if (
      ret_msg.match(/Negative MCATs/) ||
      ret_msg === "NP_Keyword"
    ) {
      htmsg = "Currently we will not be able to provide you Paid Services, Please continue with the free seller account.";
    } else if( ret_msg === "REACTIVATION POOL"){
      htmsg = "The STS cannot be marked as Hot lead Kindly raise a ticket";
    } else if (ret_msg === "NON_PRIME") {
      htmsg =
        "Currently we will not be able to provide you Paid Services due to low demand on Indiamart platform, resulting in ROI issues.";
    } else if (ret_msg === "ERROR") {
      htmsg = "Some Technical error. Kindly retry after some time.";
    } else if (ret_msg === "success") {
      htmsg = "Hotlead Created Successfully!";
    }else{
      htmsg = ret_msg
    }
    return htmsg;
  };

  export default HotLeadMessage;